


(function($) {
  $.fn.formData = function() {
    return new FormData(this[0]);
  };

  $.fn.serializeJson = function(withFormName) {
    const unIndexedArray = this.serializeArray();
    const indexedArray = {};

    $.map(unIndexedArray, (n) => {
      let val = n['value'];
      if (val === 'true' || val === 'false')  {
        val = val === 'true';
      }

      if (n['name'].slice(-2) === '[]') {
        if (!(n['name'] in indexedArray)) {
          indexedArray[n['name']] = [];
        }

        indexedArray[n['name']].push(val);
      } else {
        indexedArray[n['name']] = val;
      }
    });

    if (withFormName) {
      indexedArray.formName = this.attr('name');
    }

    return indexedArray;
  };

  $.fn.parseJson = function() {
    const unIndexedArray = this.serializeArray();
    const indexedArray = {};

    $.map(unIndexedArray, (n) => {
      indexedArray[n['name']] = value;
    });

    return indexedArray;
  };
  
  $.fn.fillForm = function(data) {
    const form = $(this);

    form.clearForm();

    if (typeof data === 'object') {
      if('formData' in data) {
        data = data.formData;
      }

      Object.keys(data).forEach((field) => {
        const val = data[field];
        let elem = form.find(`[name="${field}"]`);

        if (elem) {
          if (elem.length > 1) {
            elem.each(function() {
              if ($(this).attr('type') === 'checkbox') {
                elem = $(this);
              }
            });
          }
        }

        if (elem.attr('type') === 'checkbox') {
          elem.prop('checked', val === elem.val()).change();
        } else {
          elem.val(val).change();
        }
      });
    }
  };

  $.fn.validate = function(errors) {
    const form = $(this);

    if (Array.isArray(errors) && errors.length !== 0) {
      $.each(errors, (elementId, value) => {
        $.each(value, (index, value) => {
          form.find(`[name="${elementId}"]`).parent().addClass('has-error');
          form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
        });
      });
    }
  }
}(jQuery));
